function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlerti = function SvgAlerti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m10.051 5.291-6.715 10.96A2.3 2.3 0 0 0 3 17.4a2.29 2.29 0 0 0 1.129 2.015c.35.205.749.314 1.155.314h13.43c.406 0 .805-.109 1.155-.314a2.29 2.29 0 0 0 1.129-2.015 2.3 2.3 0 0 0-.336-1.149l-6.715-10.96a2.3 2.3 0 0 0-.832-.802 2.29 2.29 0 0 0-2.236 0 2.3 2.3 0 0 0-.832.802zm1.312.8A.75.75 0 0 1 12 5.734a.75.75 0 0 1 .636.357l6.715 10.96a.76.76 0 0 1 .11.376.76.76 0 0 1-.095.379.75.75 0 0 1-.274.279.74.74 0 0 1-.378.103H5.284a.74.74 0 0 1-.378-.103.75.75 0 0 1-.274-.279.76.76 0 0 1-.095-.379.76.76 0 0 1 .11-.376zM12 14.966a.96.96 0 0 1 .888.593.96.96 0 0 1 .055.555.97.97 0 0 1-.263.492.97.97 0 0 1-.492.264.96.96 0 0 1-.556-.055.97.97 0 0 1-.431-.354.96.96 0 0 1 .12-1.211.96.96 0 0 1 .678-.281zm-.961-5.361v3.48a.96.96 0 0 0 .961.961.96.96 0 0 0 .961-.961V9.608A.958.958 0 0 0 12 8.647a.958.958 0 0 0-.961.961z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlerti);
export default ForwardRef;